export default function FormLabel(theme) {
  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          display: 'flex !important',      // Essential for 'order' to work
          alignItems: 'center',
        },
        asterisk: {
          order: 1,             // Moves * after the text (Order 0)
          marginLeft: '2px',
          marginRight: '6px',

          color: theme.palette.error.main,

          // '.MuiStack-root:has(input:not([value=""])) &': {
          //   color: theme.palette.grey[500],
          // },

          // '.MuiStack-root:has(.MuiSelect-select:not(:empty)) &': {
          //   color: theme.palette.grey[500],
          // },

          '&.Mui-error': {
            color: theme.palette.error.main,
          },
        },
      },
    },
  };
}
